export default function checkGoodInOrder(orderGoods, goodId) {
  if (!Array.isArray(orderGoods) || orderGoods.length < 1) return false;
  const result = orderGoods.filter(i => +i.shopGood === +goodId);
  return result.length;
}
